import { Button, Modal } from 'antd'
import { type FC, type ReactNode } from 'react'
import './index.less'

interface Dialog {
  open: boolean
  title?: string
  children?: string | ReactNode
  width?: number
  close: () => void
}
const DialogBox: FC<Dialog> = (props) => {
  const {
    open, title, width,
    close,
  } = props
  return (
      <Modal
      open={open}
      destroyOnClose={true}
      centered={true}
      width={width}
      closeIcon={null} footer={null}
      mask={false}
       zIndex={9999}
       onCancel={() => {
         close()
       }}
        className={'DialogBox'}>
          <div className={'popup-head'}>
              <div className={'head-title'}>{title}</div>
              <Button className={'DialogBox-close'} onClick={close} />
          </div>
         <div className={'popup-main'}>
             {props.children}
         </div>
      </Modal>
  )
}

export default DialogBox
